<template>
  <div class="revise-password">
    <el-form
      :model="ruleForm"
      label-width="100px"
      :rules="rules"
      ref="ruleForm"
      class="password-form"
    >
      <el-form-item label="原密码：" prop="oldPassword">
        <el-input
          type="password"
          v-model="ruleForm.oldPassword"
          autocomplete="off"
          placeholder="请输入原密码"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newPassword">
        <el-input
          type="password"
          v-model="ruleForm.newPassword"
          autocomplete="off"
          placeholder="请输入新密码"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="checkPassword">
        <el-input
          type="password"
          v-model="ruleForm.checkPassword"
          autocomplete="off"
          placeholder="请再次输入新密码"
          show-password
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit" @click="submitForm('ruleForm')">提交</div>
  </div>
</template>

<script>
import JSEncrypt from "@/js_sdk/jsencrypt-Rsa/jsencrypt/jsencrypt.min.js";

export default {
  name: "",
  data() {
    // 原密码
    var validateOldPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原密码"));
      } else {
        callback();
      }
    };
    // 新密码
    var validatenNewPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.ruleForm.checkPassword !== "") {
          this.$refs.ruleForm.validateField("checkPassword");
        }
        callback();
      }
    };
    var validateCheckPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldPassword: "",
        newPassword: "",
        checkPassword: "",
      },
      rules: {
        oldPassword: [{ validator: validateOldPassword, trigger: "blur" }],
        newPassword: [{ validator: validatenNewPassword, trigger: "blur" }],
        checkPassword: [{ validator: validateCheckPassword, trigger: "blur" }],
      },

      publicKey: "", // 公钥
      encryptorOldPassword: "", // 加密后的旧密码
      encryptorNewPassword: "", // 加密后的新密码
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          // console.log("验证通过");
          // 调用接口，修改密码
          this.updateTeacherPwdPC();
        } else {
          return false;
        }
      });
    },
    // 调用接口，修改密码
    updateTeacherPwdPC() {
      // 密码md5加密
      this.encryptorOldPassword = this.$md5(this.ruleForm.oldPassword);
      this.encryptorNewPassword = this.$md5(this.ruleForm.newPassword);
      this.post(this.$url.updateTeacherPwdPC, {
        id: this.user.id,
        oldPassword: this.encryptorOldPassword,
        newPassword: this.encryptorNewPassword,
      })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("修改成功，请重新登录");
            this.$store.dispatch("user/resetToken").then((res) => {
              this.$router.push("/login");
            });
          } else {
            this.$message.error(res.msg || "修改失败");
          }
        })
        .catch((err) => {
          this.$message.error("修改失败，请稍后再试");
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./revise-password.scss";
</style>
